@if (viewModel) {
  <div class="exception-popup">
    <div class="error-container">
      @for (error of viewModel.errors; track error) {
        <div class="code-wrapper" [class.is-selected]="(viewModel.selectedError$ | async) === error" >
          @if (error?.description) {
            <pre (click)="viewModel.selectedError$.next(error)" class="code code-description"><code>{{error.description}}</code></pre>
          }
        </div>
      }
    </div>
    @if (viewModel.selectedError$ | async) {
      <nts-expandable [title]="'std_Expandable_Main_DisplayName' | NTSTranslate" [isCollapsed]="true">
        @if ((viewModel.selectedError$ | async)?.uuid?.length > 0) {
          <nts-label-box [label]="'ExceptionPopup_TraceCode_Label' | NTSTranslate:([(viewModel.selectedError$ | async).uuid])"></nts-label-box>
        }
        <nts-label-box [label]="'ExceptionPopup_User_Label' | NTSTranslate:([viewModel.userName$ | async])"></nts-label-box>
        <nts-label-box [label]="'ExceptionPopup_Company_Label' | NTSTranslate:([$safeNavigationMigration((viewModel.currentCompany$ | async)?.name)])"></nts-label-box>
        <nts-label-box [label]="'ExceptionPopup_Enterprise_Label' | NTSTranslate:([$safeNavigationMigration((viewModel.currentEnterprise$ | async)?.name)])"></nts-label-box>
        <nts-label-box [label]="'ExceptionPopup_Tenant_Label' | NTSTranslate:([$safeNavigationMigration((viewModel.tenantProfile$ | async)?.businessName)])"></nts-label-box>
      </nts-expandable>
    }
    @if (((viewModel.selectedError$ | async)?.requestInfo); as requestInfo) {
      <nts-expandable [title]="'ExceptionPopup_HTTP_Request' | NTSTranslate" [isCollapsed]="true">
        <div class="code-wrapper" [class.dark]="viewModel.darkMode$ | async">
          @if (requestInfo?.method) {
            <pre class="code code-html"><label>{{'ExceptionPopup_URL'| NTSTranslate}}</label><code>{{requestInfo.method}} {{requestInfo.url}}</code></pre>
          }
          @if (requestInfo?.headers) {
            <pre class="code code-html"><label>{{ 'ExceptionPopup_Headers' | NTSTranslate}}</label><code>{{requestInfo.headers | json}}</code></pre>
          }
          @if (requestInfo?.tokenInfo) {
            <pre class="code code-html"><label>{{ 'ExceptionPopup_Token' | NTSTranslate}}</label><code>{{requestInfo.tokenInfo | json}}</code></pre>
          }
          @if (requestInfo?.payload) {
            <pre class="code code-html"><label>{{ 'ExceptionPopup_Payload' | NTSTranslate}}</label><code>{{requestInfo.payload | json}}</code></pre>
          }
        </div>
      </nts-expandable>
    }
    @if (((viewModel.selectedError$ | async)?.responseInfo); as responseInfo) {
      <nts-expandable [title]="'ExceptionPopup_HTTP_Response' | NTSTranslate" [isCollapsed]="true">
        <div class="code-wrapper" [class.dark]="viewModel.darkMode$ | async">
          @if (responseInfo?.status) {
            <pre class="code code-html"><label>{{ 'ExceptionPopup_HTTP_Status' | NTSTranslate}}</label><code>{{responseInfo.status}}</code></pre>
          }
          @if (responseInfo?.headers) {
            <pre class="code code-html"><label>{{ 'ExceptionPopup_Headers' | NTSTranslate}}</label><code>{{responseInfo.headers | json}}</code></pre>
          }
          @if (responseInfo?.response) {
            <pre class="code code-html"><label>{{ 'ExceptionPopup_Response' | NTSTranslate}}</label><code>{{responseInfo.response | json}}</code></pre>
          }
        </div>
      </nts-expandable>
    }
    @if (((viewModel.selectedError$ | async)?.stackTrace); as stackTrace) {
      <nts-expandable [title]="'ExceptionPopup_StackTrace' | NTSTranslate" [isCollapsed]="true"  [commands]="[viewModel.switchModeCommand]">
        <div class="code-wrapper" [class.dark]="viewModel.darkMode$ | async">
          @if (stackTrace) {
            <pre class="code code-html"><label>{{'ExceptionPopup_StackTrace' | NTSTranslate}}</label><code>{{stackTrace}}</code></pre>
          }
        </div>
      </nts-expandable>
    }
  </div>
}
